
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#444444"}}),_c('path',{attrs:{"d":"M12.472 14.8643C11.8427 14.2404 11.8427 13.2289 12.472 12.605C13.1013 11.9811 14.1215 11.9811 14.7508 12.605L27.528 25.2728C28.1573 25.8967 28.1573 26.9082 27.528 27.5321C26.8988 28.156 25.8785 28.156 25.2493 27.5321L12.472 14.8643Z","fill":"#F8F8F8"}}),_c('path',{attrs:{"d":"M14.7507 27.395C14.1215 28.0189 13.1012 28.0189 12.472 27.395C11.8427 26.7711 11.8427 25.7596 12.472 25.1357L25.2492 12.4679C25.8785 11.844 26.8987 11.844 27.528 12.4679C28.1573 13.0918 28.1573 14.1033 27.528 14.7272L14.7507 27.395Z","fill":"#F8F8F8"}})])
          )
        }
      }
    